import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextLive = createSVG({
    width: 48,
    children: (jsx("path", { d: "M10.667 6v9.737h4.577V18H8.302V6zm8.287 12H16.59V6h2.365zm3.731-12 2.93 9.223L28.53 6h2.588l-4.045 12h-2.931L20.113 6zm16.927 2.263h-4.971v2.554h4.543v2.229H34.64v2.691h5.057V18h-7.423V6h7.337z" })),
});

export { IconTextLive };
